import React from 'react';
import { carryMessageLines } from '../../lib/coachCarryDisplay';

/** 막힌 이유와 다음 행동을 같은 모양으로 보여 줘요. 서버가 준 안내는 생략하지 않아요. */
const CoachNotice = ({ message }: { message: string }) => {
    const { issue, action } = carryMessageLines(message);
    return <span className="block break-keep text-[13px] leading-[21px]">
        <span className="block font-medium">{issue}</span>
        {action && <span className="mt-[4px] block font-normal">{' '}{action}</span>}
    </span>;
};

export default CoachNotice;
